export default __webpack_public_path__ + "static/smallVenue_thumbnail-20238ba6ddd013e340e017bb934c0216.png";